export const CONFIG = {
    URL: 'https://proxykeeper.com',
    NAME: 'ProxyKeeper',
    MAIL: 'proxykeeper.help@gmail.com'
}